import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import {
  AdminPushService,
  type ApiError,
  type PushAudience,
  type PushCampaignRequest,
} from '@/shared/api'

// === ПУШ-РАССЫЛКИ (АДМИНКА) ===

// Ключи React Query
const QUERY_KEYS = {
  history: (page: number) => ['push', 'history', page] as const,
}

/** Количество получателей аудитории; запрашивается по клику */
export const usePushAudienceCount = () => {
  return useMutation({
    mutationFn: (audience: PushAudience) =>
      AdminPushService.audienceCount(audience),
  })
}

/** Отправка рассылки выбранной аудитории */
export const useSendPushCampaign = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: PushCampaignRequest) =>
      AdminPushService.send(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['push', 'history'] })
      toast.success('Пуш придёт в течение минуты')
    },
    onError: (error: ApiError) => {
      if (!error?.alreadyToasted) {
        toast.error(error.detail || 'Не удалось отправить рассылку')
      }
    },
  })
}

/** Повторная отправка сохранённой кампании */
export const useResendPushCampaign = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => AdminPushService.resend(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['push', 'history'] })
      toast.success('Пуш придёт в течение минуты')
    },
    onError: (error: ApiError) => {
      if (!error?.alreadyToasted) {
        toast.error(error.detail || 'Не удалось отправить рассылку')
      }
    },
  })
}

/** История рассылок и системных пушей */
export const usePushHistory = (page: number) => {
  return useQuery({
    queryKey: QUERY_KEYS.history(page),
    queryFn: () => AdminPushService.history(page),
    staleTime: 30 * 1000,
  })
}
